import { ReportErrorType, ReportErrorAttributes } from 'app/shared/models/error-reporting';
declare let newrelic: any;

class ErrorReportingService {
  public logError(err: Error | string, errType: ReportErrorType): void {
    if (!this.newRelicAvailable) return;
    const error = typeof err === 'string' ? new Error(err) : err;
    const errorAttributes: ReportErrorAttributes = { errorType: errType };
    newrelic.noticeError(error, errorAttributes);
  }

  private get newRelicAvailable(): boolean {
    return typeof newrelic === 'object' && typeof newrelic.noticeError === 'function';
  }
}

export const errorReportingService = new ErrorReportingService();
